/**
 * log.error({err:err,args:{}},'');
 * https://github.com/trentm/node-bunyan
 * [Bunyan does not print to Stdout when debugging in VSCode ](https://github.com/trentm/node-bunyan/issues/545)
 */
const os = require('os');
const bunyan = require('bunyan');

/**
 * 解析request ，增加body记录
 * @param {*} req
 */
function serializerReq(req) {
  if (!req) return req;
  return {
    method: req.method,
    url: req.url,
    headers: req.headers,
    body: req.body,
    remoteAddress: req.socket.remoteAddress,
    remotePort: req.socket.remotePort
  };
}

// Serialize an HTTP response.
function stdSerializerRes(res) {
  if (!res) return res;
  return {
    status: res.status,
    header: res.header,
    body: res.body
  };
}

exports.createLogger = function(opts) {
  let hostname = process.env.HOSTNAME ? process.env.HOSTNAME : os.hostname();
  let core = Object.assign(
    {
      hostname: hostname,
      serializers: {
        req: serializerReq,
        res: stdSerializerRes,
        err: bunyan.stdSerializers.err
      }
    },
    opts
  );
  return bunyan.createLogger(core);
};
